<template>
    <div id="cookie-consent-wrapper" v-show="!isSet('cookie_consent')">
        <div id="cookie-message">
            <div class="grid-container">
                <div class="grid-x grid-margin-x">
                    <div class="cell small-12 medium-auto">
                        <slot>
                            <p>
                                We use cookies to help provide you with the best possible online experience.<br />
                                By using this site, you agree that we may store and access cookies on your device. <a href="/cookies">Find out about our cookies.</a>
                            </p>
                        </slot>
                    </div>
                    <div class="cell small-12 medium-shrink">
                        <button type="button" class="button" @click.prevent="set('cookie_consent')">ACCEPT ALL COOKIES</button>
                        <button type="button" class="button" @click.prevent="toggle">
                            <span v-if="!show">SHOW OPTIONS</span>
                            <span v-else>HIDE OPTIONS</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="cookie-settings" v-if="show">
            <div class="grid-container">
                <CookieSetup />
            </div>
        </div>
    </div>
</template>
<script>
    import BaseCookie from './BaseCookie';
    import CookieSetup from './CookieSetup';
    export default {
      mixins: [BaseCookie],
      components: {CookieSetup},
      data() {
        return {
          show: false
        }
      },
      methods: {
        toggle() {
          this.show = !this.show;
        }
      }
    }
</script>